import type { Badges } from '@/entities/layout';

import { MENU_ITEM_BADGE_KEYS } from '../model/constants';
import type { NavigationItemWithState } from '../model/types';

/**
 * Attaches the backend badge counters to the menu items they belong to
 * (recursively for sub-items). A group carries the sum of its sub-items so the
 * number survives collapsing; zero is left unset so no empty badge is drawn.
 */
export const withBadges = (items: NavigationItemWithState[], badges?: Badges): NavigationItemWithState[] =>
  items.map((item) => {
    const subItems = item.subItems && withBadges(item.subItems, badges);
    const badge = subItems?.length
      ? subItems.reduce((total, subItem) => total + (subItem.badge ?? 0), 0)
      : badges?.[MENU_ITEM_BADGE_KEYS[item.code]];

    return { ...item, badge: badge || undefined, subItems };
  });
